
import {Component, Prop, Vue} from 'vue-property-decorator';
import {importe} from '@/helpers/ventana-al-guardar';

/**
 * N-288 · T3 (1B) · La ventana de GUARDAR: lo que se quita y lo que cambia de precio (maqueta
 * `1b-ventana-al-guardar.jpg`). `ventana` = null, cerrada; si no, {entradilla, tituloQuitan, quitan,
 * tituloCambian, cambian}. «Volver y revisar» emite `volver`; «Guardar así», `guardar`.
 */
@Component({})
export default class VentanaAlGuardar extends Vue {
	@Prop({ default: null, required: false }) private ventana;

	importe(valor) {
		return importe(valor);
	}
}
